import { Box } from "@chakra-ui/react"
import AdLayout from "../AdLayout"
import SideInfo from "../Extra/SideInfo"

// https://freesvg.org/organs-of-the-human-body

import {AdDefault} from './../Juegos/Juegos'

import Organos from "./Organos"

const Proceso = () => {
    return <>
        <AdLayout BoxA={AdDefault} BoxC={AdDefault} BoxB={ProcesoInf}/>
    </>
}

const ProcesoInf = () => {
    return <Box>
        <Organos/>
    </Box>
}

export default Proceso
